module.exports = __webpack_public_path__ + "static/media/simple_sms.031dbb8b.mp3";